/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AnalyticsStepType,
    AnalyticsStepTypeFromJSON,
    AnalyticsStepTypeFromJSONTyped,
    AnalyticsStepTypeToJSON,
} from './AnalyticsStepType';
import {
    CurrencySeriesPoint,
    CurrencySeriesPointFromJSON,
    CurrencySeriesPointFromJSONTyped,
    CurrencySeriesPointToJSON,
} from './CurrencySeriesPoint';
import {
    DateMacro,
    DateMacroFromJSON,
    DateMacroFromJSONTyped,
    DateMacroToJSON,
} from './DateMacro';
import {
    EventAnalyticsObjectType,
    EventAnalyticsObjectTypeFromJSON,
    EventAnalyticsObjectTypeFromJSONTyped,
    EventAnalyticsObjectTypeToJSON,
} from './EventAnalyticsObjectType';
import {
    NumberRadialPoint,
    NumberRadialPointFromJSON,
    NumberRadialPointFromJSONTyped,
    NumberRadialPointToJSON,
} from './NumberRadialPoint';
import {
    NumberSeriesPoint,
    NumberSeriesPointFromJSON,
    NumberSeriesPointFromJSONTyped,
    NumberSeriesPointToJSON,
} from './NumberSeriesPoint';

/**
 * 
 * @export
 * @interface EventAnalytics
 */
export interface EventAnalytics {
    /**
     * 
     * @type {DateMacro}
     * @memberof EventAnalytics
     */
    date_macro: DateMacro;
    /**
     * 
     * @type {AnalyticsStepType}
     * @memberof EventAnalytics
     */
    unit: AnalyticsStepType;
    /**
     * 
     * @type {Date}
     * @memberof EventAnalytics
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventAnalytics
     */
    end_date: Date;
    /**
     * 
     * @type {EventAnalyticsObjectType}
     * @memberof EventAnalytics
     */
    object: EventAnalyticsObjectType;
    /**
     * The sum of all the components
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    total_volume: Array<CurrencySeriesPoint>;
    /**
     * The subtotal with included fees
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    gross_volume: Array<CurrencySeriesPoint>;
    /**
     * The sum of taxes
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    gross_taxed_volume: Array<CurrencySeriesPoint>;
    /**
     * The sum of fees
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    gross_fee_volume: Array<CurrencySeriesPoint>;
    /**
     * Total amount refunded
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    refunded_volume: Array<CurrencySeriesPoint>;
    /**
     * The amount made from sales - included fees
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    net_sales_volume: Array<CurrencySeriesPoint>;
    /**
     * The sum of all the components related to sales
     * @type {Array<CurrencySeriesPoint>}
     * @memberof EventAnalytics
     */
    total_sales_volume: Array<CurrencySeriesPoint>;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof EventAnalytics
     */
    new_registrations: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof EventAnalytics
     */
    new_contacts: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberSeriesPoint>}
     * @memberof EventAnalytics
     */
    new_attendees: Array<NumberSeriesPoint>;
    /**
     * 
     * @type {Array<NumberRadialPoint>}
     * @memberof EventAnalytics
     */
    feedback_ratings: Array<NumberRadialPoint>;
}

export function EventAnalyticsFromJSON(json: any): EventAnalytics {
    return EventAnalyticsFromJSONTyped(json, false);
}

export function EventAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAnalytics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date_macro': DateMacroFromJSON(json['date_macro']),
        'unit': AnalyticsStepTypeFromJSON(json['unit']),
        'start_date': (new Date(json['start_date'])),
        'end_date': (new Date(json['end_date'])),
        'object': EventAnalyticsObjectTypeFromJSON(json['object']),
        'total_volume': ((json['total_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'gross_volume': ((json['gross_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'gross_taxed_volume': ((json['gross_taxed_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'gross_fee_volume': ((json['gross_fee_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'refunded_volume': ((json['refunded_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'net_sales_volume': ((json['net_sales_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'total_sales_volume': ((json['total_sales_volume'] as Array<any>).map(CurrencySeriesPointFromJSON)),
        'new_registrations': ((json['new_registrations'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'new_contacts': ((json['new_contacts'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'new_attendees': ((json['new_attendees'] as Array<any>).map(NumberSeriesPointFromJSON)),
        'feedback_ratings': ((json['feedback_ratings'] as Array<any>).map(NumberRadialPointFromJSON)),
    };
}

export function EventAnalyticsToJSON(value?: EventAnalytics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date_macro': DateMacroToJSON(value.date_macro),
        'unit': AnalyticsStepTypeToJSON(value.unit),
        'start_date': (value.start_date.toISOString()),
        'end_date': (value.end_date.toISOString()),
        'object': EventAnalyticsObjectTypeToJSON(value.object),
        'total_volume': ((value.total_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'gross_volume': ((value.gross_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'gross_taxed_volume': ((value.gross_taxed_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'gross_fee_volume': ((value.gross_fee_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'refunded_volume': ((value.refunded_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'net_sales_volume': ((value.net_sales_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'total_sales_volume': ((value.total_sales_volume as Array<any>).map(CurrencySeriesPointToJSON)),
        'new_registrations': ((value.new_registrations as Array<any>).map(NumberSeriesPointToJSON)),
        'new_contacts': ((value.new_contacts as Array<any>).map(NumberSeriesPointToJSON)),
        'new_attendees': ((value.new_attendees as Array<any>).map(NumberSeriesPointToJSON)),
        'feedback_ratings': ((value.feedback_ratings as Array<any>).map(NumberRadialPointToJSON)),
    };
}

